import { Body1 } from 'stories/elements/Typography/Text'
import { Know, KnowTranscript } from 'interfaces/Know'
import { returnTranscriptText } from 'lib/features/Know/know'
import styled from 'styled-components'
import theme from 'stories/utils/theme'

const KnowBasicTranscriptWrapper = styled(Body1)`
    overflow-wrap: anywhere;
    font-size: 14px;
    padding: 25px 5%;
    color: ${theme.colors.body1Black};
    @media (max-width: 1050px) {
        padding: 5px 25px;
    }
    @media (min-width: 1921px) {
        width: 100%;
        max-width: 1575px;
        margin: 0 auto;
        padding: 50px 0;
    }
    * {
        overflow-wrap: anywhere;
        word-break: break-all;
        white-space: pre-line;
    }
`

interface Props {
    transcript: KnowTranscript | null
    know: Know
}

const KnowSEOTranscriptBeginning = ({ transcript: knowTranscript }: Props) => {
    const { transcript } = knowTranscript || {}

    if (!transcript) return null

    return (
        <>
            <KnowBasicTranscriptWrapper fontFamily="var(--font-inter)" fontWeight={400}>
                {returnTranscriptText(transcript, true)}
            </KnowBasicTranscriptWrapper>
        </>
    )
}

export default KnowSEOTranscriptBeginning
